<style lang="scss" src='./Account.scss' scoped></style>
<template src="./Account.html"></template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations,
    mapGetters,
  } from "vuex";

  import InputMap from '@/components/inputMap/InputMap'
  import DeleteOrderModal from '@/components/deleteOrderModal/DeleteOrderModal'
  import InputPassword from "@/components/inputPassword/InputPassword.vue";
  import ReviewOrderModal from "@/components/reviewOrderModal/ReviewOrderModal.vue";
  import moment from 'moment';
  import StarsRaiting from '@/components/starsRaiting/StarsRaiting'

  export default {
    name: "Account",
    components: {
      InputMap,
      InputPassword,
      DeleteOrderModal,
      ReviewOrderModal,
      StarsRaiting,
    },
    data() {
      return {
        editUserinfo: false,
        editAddress: false,
        tempUser: {
          first_name: null,
          last_name: null,
          last_name_2: null,
          phone: null,
          email: null,
          address: null,
          notes: null,
          zip_code: null,
          latitude: null,
          longitude: null,
          language: null,
        },
        pass: {
          pass1: null,
          pass2: null,
        },
        currentPass: null,
        dateRage: 30,
        loading: {
          update: false,
          password: false,
          address: false,
          cancel: false,
          to_cart: false,
        },
        order_id_to_cart: null,
        tabIndex: 0,
      }
    },
    computed: {
      ...mapState(['user', 'forms', 'orderList', 'car']),
      ...mapState('CartStore', ['cartProducts']),
      ...mapGetters('Main', ['getStoreList']),
    },
    watch: {
      '$route.query': {
        handler: function (query) {
          if( query.tab == 'account'){
            this.tabIndex = 0;
          }else{
            this.tabIndex = 1;
          }
        },
        deep: true,
        immediate: true
      }
    },

    methods: {
      ...mapActions(['fnApiGetMe', 'fnApiUpdateUser', 'fnApiGetOrders', 'fnApiChangePassword', 'fnApiUpdateUserAddress']),
      ...mapActions('CartStore', ['fnApiPreviousOrder']),
      ...mapMutations(['setForm']),
      async fnValidateUser() {
        if (await this.$refs['formUser'].validate()) {
          let userData = {
            first_name: this.tempUser.first_name,
            last_name: this.tempUser.last_name,
            phone: this.tempUser.phone,
          }
          this.tempUser.last_name_2 && (userData.last_name_2 = this.tempUser.last_name_2);
          this.tempUser.email && (userData.email = this.tempUser.email);
          (this.tempUser.store_id != this.user.store_id) && (userData.store_id = this.tempUser.store_id)
          this.loading.update = true;
          await this.fnApiUpdateUser(userData);
          this.loading.update = false;
        }
      },
      async fnValidatePassword() {
        if (await this.$refs['formPassword'].validate() && (this.pass.pass1 == this.pass.pass2)) {
          let data = {
            password: this.currentPass,
            new_password: this.pass.pass1
          }
          this.loading.password = true;
          await this.fnApiChangePassword([data, this.fnHidePasswordForm]);
          this.loading.password = false;
        }
      },

      async fnValidateAddress() {
        let address = await this.$refs['address'].fnValidate();
        if (address) {
          this.loading.address = true;
          await this.fnApiUpdateUserAddress([address, this.fnHideAddressForm]);
          this.loading.address = false;
        }
      },

      fnHideUserForm() {
        this.setForm({
          user: false
        })
        this.tempUser = {
          ...this.user
        };
      },

      fnHideAddressForm() {
        this.setForm({
          address: false
        })
        this.tempUser = {
          ...this.user
        };
      },

      fnHidePasswordForm() {
        this.currentPass = null;
        this.pass.pass1 = null;
        this.pass.pass2 = null;
        this.$refs['formPassword'].reset();
      },

      fnGetDate(order) {
        let {
          date,
          start_time
        } = order.delivery_method.delivery_time;
        return moment(date + ' ' + start_time).format(' DD/MM/YYYY, hh:mm A');
      },

      async fnGetAgain(orderId) {
        let condition = true;
        if (this.cartProducts.products.length > 0) {
          condition = await this.$bvModal.msgBoxConfirm(this.$t('general.reorderConfirmation'), {
            title: this.$t('general.confirmation'),
            size: 'md',
            buttonSize: 'md',
            okVariant: 'success',
            okTitle: this.$t('general.yes'),
            cancelTitle: this.$t('general.no'),
            centered: true
          });
        }
        if (condition) {
          this.loading.to_cart = true;
          this.order_id_to_cart = orderId;
          await this.fnApiPreviousOrder(orderId);
          this.loading.to_cart = false;
          this.order_id_to_cart = null;
        }
      },

      fnGetOrderStatus(order) {
        switch (order.status) {
          case 'PROCESSING':
            return this.$t('order.status.preparing');
          case 'READY':
            return this.$t('order.status.ready');
          case 'OUT_FOR_DELIVERY':
            return this.$t('order.status.delivering');
          case 'DELIVERED':
            return this.$t('order.status.delivered');
          case 'CANCELED':
            return this.$t('order.status.canceled');
          case 'RETURNED':
            return this.$t('order.status.returned');
          default:
            return this.$t('order.status.placed');
        }
      },

      fnGetOrderStatusPillColor(order) {
        switch (order.status) {
          case 'PROCESSING':
            return 'info';
          case 'READY':
            return 'orange';
          case 'OUT_FOR_DELIVERY':
            return 'purple';
          case 'DELIVERED':
            return 'success';
          case 'CANCELED':
            return 'gray';
          case 'RETURNED':
            return 'gray';
          default:
            return 'warning';
        }
      },

      fnDeleteOrder(orderId) {
        this.$refs['deleteOrder'].orderId = orderId;
        this.$refs['deleteOrder'].showModal = true;
      },

      fnOrderReview(order) {
        this.$refs['reviewOrderModal'].orderInfo = {
          ...order
        };
        this.$refs['reviewOrderModal'].showModal = true;
      },

      fnBack() {
        this.$router.push({
          path: '/'
        });
      },

      fnGetPrederedStore() {
        let pref_store_id = this.user.store_id;
        if(pref_store_id){
          let store = this.getStoreList.find(x => x.store_id == pref_store_id);
          if(store){
            return store.short_name
          }
        }
        return '-'
      },

    },

    beforeCreate() {},

    created() {
      this.tempUser = {
        ...this.user
      };
      window.fbq('track', 'PageView');
    },

    mounted() {
      this.fnApiGetMe();
      this.fnApiGetOrders(this.dateRage);
      this.forms.user = false;
      this.forms.address = false;
    },

    beforeDestroy() {},
  };

</script>
